import type { BillingNote } from '@policyvision/contracts';

import { useBillingNoteTemplates } from './useBillingNoteTemplates';

export const useBillingNoteText = (
  note: Pick<BillingNote, 'templateId' | 'content'> | null,
) => {
  const { templates } = useBillingNoteTemplates();

  if (!note) return '';

  return (
    templates.find(({ id }) => id === note.templateId)?.label ||
    note.content ||
    ''
  );
};
